<template>
  <div class="jackrabbit-child">

    <div class="child-select child-selecting" v-if="!child.added">

      <div class="flex flex-row gap-2 items-center">
        <div>{{ str_age }}</div>
        <select v-model="child.category2">
          <option value="">{{ str_choose }}</option>
          <option v-for="label in category2" :value="label">{{ label }}</option>
        </select>
      </div>


      <div class="flex flex-row gap-2 items-center">
        <div v-if="child.category2 != ''">{{ str_level }}</div>
        <select v-model="child.category3" v-if="child.category2 != ''">
          <option value="">{{ str_choose }}</option>
          <option v-for="label in category3" :value="label">{{ label }}</option>
        </select>
      </div>


      <div class="flex flex-row items-center gap-2">
        <div v-if="child.category2 != '' && child.category3 != ''">
          {{ child.openings.length }} {{ str_openings }}
        </div>

        <button v-if="child.category2 != '' && child.category3 != ''"
                class="add-child-button" @click.prevent="addChild"
        >{{ str_add_child }}</button>

        <button v-if="child.category2 != '' && child.category3 != ''"
                class="cancel-child-button" @click.prevent="cancelChild"
        >{{ str_cancel }}</button>
      </div>

    </div>

    <div class="child-select child-selected" v-if="child.added">
      <div class="child-select-color" :style="{'background-color': colorForCategory2(child.category2)}"></div>
      <div>{{ str_child }}</div>
      <div>{{ child_index }}</div>:
      <div><strong>{{ child.category2 }}</strong></div> -
      <div><strong>{{ child.category3 }}</strong></div>
      <button class="add-child-button" @click.prevent="removeChild"
      >{{ str_remove }}</button>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    jr_endpoint: {
      required: true,
    },
    category2: {
      required: true,
      default: () => []
    },
    child_index: {
      default: 0
    },
    color: {
      default: '#009900',
    },
    child: {
      required: false,
      default: () => {
        return {
          added: false,
          category2: '',
          category3: '',
          openings: []
        }
      }
    },
    colorForCategory2: {
      required: true,
      type: Function
    },
    colorForCategory3: {
      required: true,
      type: Function
    }
  },

  watch: {
    'child.category2'(){
      //console.log('Category 2 has changed')
      this.fillCategory3()
    },
    'child.category3'(){
      //console.log('Category 2 has changed')
      this.fillOpenings()
    }
  },

  data(){
    return {
      // Preselection for the child
      sel1: null,
      sel2: null,

      str_age: this.__("Age"),
      str_level: this.__("Level"),
      str_choose: this.__("Choose"),
      str_add_child: this.__("Add Child"),
      str_remove: this.__("Remove"),
      str_cancel: this.__("Cancel"),
      str_child: this.__("Child"),
      str_openings: this.__("Openings"),
      added: false,
      category3: [],
    }
  },

  methods: {
    __(label) {
      return label
    },

    fillCategory3() {
      this.child.category3 = ""

      // Load openings and prepare available category 3
      let jr_endpoint = this.jr_endpoint + '&Cat2=' + this.child.category2

      jQuery.getJSON(jr_endpoint, (response) => {
        console.log(response)
        if (response.success) {
          let category3 = []
          for (let i = 0; i < response.rows.length; i++){
            let cat3 = response.rows[i].category3
            if (!category3.includes(cat3)){
              category3.push(cat3)
            }
          }
          this.category3 = category3.sort()

          this.$nextTick(() => {
            this.loadSelector2IfExists()
          })
        }
      })
    },

    fillOpenings(){

      let jr_endpoint = this.jr_endpoint + '&Cat2=' + this.child.category2 + '&Cat3=' + this.child.category3

      jQuery.getJSON(jr_endpoint, (response) => {
        if (response.success) {
          this.addOpenings(response.rows)
        }
      })
    },

    addOpenings(rows) {
      this.child.openings = []
      for(let i = 0; i < rows.length; i++){
        this.addOpening(rows[i])
      }
    },

    addOpening(row) {
      let weekdays = {
        mon: 1,
        tue: 2,
        wed: 3,
        thu: 4,
        fri: 5,
        sat: 6,
        sun: 7
      };

      let weeknames = {
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Friday'
      }

      Object.keys(weekdays).forEach( (key) => {

        let weekindex = weekdays[key]
        //console.log(key +  ' - ' + weekindex)

        if (row.meeting_days[key])
        {
          if (row.openings.calculated_openings > -10) {
            let opening = {
              closed: true,
              child_index: this.child_index,
              week_day_label: weeknames[key],
              week_day_index: weekindex,
              openings: row.openings.calculated_openings,
              days: row.openings.days,
              link: row.online_reg_link,
              start_time: row.start_time,
              end_time: row.end_time,
              instructors: row.instructors
            }
            this.child.openings.push(opening)
          }
        }
      })

    },

    addChild(){
      this.child.added = true
    },

    cancelChild(){
      this.removeChild()
    },

    removeChild(){
      //console.log('Remove Child')
      this.$emit('remove')
    },

    loadSelectors(sel1, sel2) {
      //console.log('Load selectors')
      //console.log(sel1)
      //console.log(sel2)

      for (let i = 0; i < this.category2.length; i++){
        if (this.category2[i] == sel1) {
          this.child.category2 = sel1
          this.sel1 = sel1
        }
      }
      this.sel2 = sel2
    },

    loadSelector2IfExists()
    {
      if (!this.sel2) return

      for (let i = 0; i < this.category3.length; i++){
        if (this.category3[i] == this.sel2)
        {
          this.child.category3 = this.sel2

          // Now press the append child button
          this.$nextTick(() => {
            this.addChild()
          })
        }
      }
    }
  }
}
</script>
